import { ref } from "vue";

export const pageScrollToTop = ref<Record<string, number | undefined>>({});